<template>
  <div class="licensed-page-expiry-container">
    <div v-if="isPermissionDenied" class="permission-denied">
      <div class="permission-denied-content">
        <h2>{{ $t('common.no_permission') }}</h2>
        <p>{{ $t('licensedPageExpiry.no_permission_message') }}</p>
      </div>
    </div>
    <div v-else class="licensed-page-expiry-wrapper">
      <!-- Loading Spinner -->
      <div v-if="loading" class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ $t('loading') }}</p>
      </div>

      <!-- Report Content -->
      <div v-else class="report-content">
        <!-- Generate Report Button -->
        <!-- <div class="generate-report-section">
          <button class="generate-report-button" @click="generateReport" :disabled="loading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ $t('licensedPageExpiry.generateReport') }}
          </button>
        </div> -->

        <!-- Filters Section -->
        <!-- <div class="filters-section">
          <div class="filters-container">
            <div class="filterGroup">
              <MultiSelectDropdown :label="$t('licensedPageExpiry.tenantIds')" :placeholder="$t('licensedPageExpiry.tenantIdsPlaceholder')" v-model="filters.tenantIds" :options="tenantOptions" />
            </div>
            <div class="filterButtonGroup">
              <button class="resetDateButton" @click="handleSearch">{{ $t('reports.search') }}</button>
              <button class="resetDateButton" @click="resetAllFilters">{{ $t('licensedPageExpiry.clearFilters') }}</button>
            </div>
          </div>
        </div> -->

        <!-- Summary Section -->
        <div v-if="summaryData" class="summary-section">
          <div class="summary-card">
            <div class="summary-item">
              <span class="summary-label">{{ $t('licensedPageExpiry.totalTenants') }}</span>
              <span class="summary-value">{{ summaryData.total_count || 0 }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">{{ $t('licensedPageExpiry.thresholdPercent') }}</span>
              <span class="summary-value">{{ summaryData.threshold_percent || 0 }}%</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">{{ $t('licensedPageExpiry.generatedOn') }}</span>
              <span class="summary-value">{{ summaryData.generated_on || '' }}</span>
            </div>
          </div>
        </div>

        <!-- Pagination Controls -->
        <!-- <div class="pagination-controls">
          <div class="pagination-info">
            <span>{{ $t('reports.showing') }} {{ (page - 1) * pageSize + 1 }}-{{ Math.min(page * pageSize, total) }} {{ $t('reports.of') }} {{ total }}</span>
          </div>
          <div class="pagination-buttons">
            <button @click="goToPreviousPage" :disabled="page === 1" class="pagination-button">
              {{ $t('reports.previous') }}
            </button>
            <span class="page-info">{{ $t('reports.page') }} {{ page }} {{ $t('reports.of') }} {{ totalPages }}</span>
            <button @click="goToNextPage" :disabled="page === totalPages" class="pagination-button">
              {{ $t('reports.next') }}
            </button>
          </div>
          <div class="page-size-controls">
            <div class="page-size-dropdown" ref="dropdownEl">
              <button @click="togglePageSizeDropdown" class="page-size-button">
                {{ pageSize }} {{ $t('reports.per_page') }}
                <svg class="dropdown-icon" :class="{ rotated: showPageSizeDropdown }" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="#5C656C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <div v-if="showPageSizeDropdown" class="page-size-options">
                <button v-for="size in pageSizeOptions" :key="size" @click="selectPageSize(size)" :class="{ active: pageSize === size }" class="page-size-option">
                  {{ size }}
                </button>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Download Buttons -->
        <div class="download-section">
          <button @click="downloadAsPDF" :disabled="downloadingPDF || licensedPageData.length === 0" class="downloadExcelButton pdf-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <polyline points="10,9 9,9 8,9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ downloadingPDF ? $t('reports.downloading') : $t('reports.download_pdf') }}
          </button>
          <button @click="downloadAsExcel" :disabled="downloadingExcel || licensedPageData.length === 0" class="downloadExcelButton excel-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8 13h8M8 17h8M8 9h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ downloadingExcel ? $t('reports.downloading') : $t('reports.download_excel') }}
          </button>
        </div>

        <!-- Data Table -->
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>{{ $t('licensedPageExpiry.tableHeaders.tenantId') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.tenantName') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.pagesLicensed') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.pagesProcessed') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.pagesRemaining') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.utilizationPercent') }}</th>
                <th>{{ $t('licensedPageExpiry.tableHeaders.status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in licensedPageData" :key="item.tenant_id">
                <td>{{ item.tenant_id }}</td>
                <td>{{ item.tenant_name }}</td>
                <td>{{ item.pages_licensed }}</td>
                <td>{{ item.pages_processed }}</td>
                <td>
                  <span :class="getPagesRemainingClass(item.pages_remaining)" class="pages-badge">
                    {{ item.pages_remaining }}
                  </span>
                </td>
                <td>{{ item.utilization_percent.toFixed(2) }}%</td>
                <td>
                  <span :class="getStatusClass(item.status)" class="status-badge">
                    {{ $t(`licensedPageExpiry.status.${item.status.toLowerCase().replace(' ', '_')}`) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- No Data Message -->
          <div v-if="licensedPageData.length === 0" class="no-data">
            <p>{{ $t('licensedPageExpiry.noData') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/api'
import { showToast } from '../../utils/toast.js'
export default {
  name: 'LicensedPageExpiryReport',
  components: {},
  data() {
    return {
      loading: false,
      licensedPageData: [],
      readPermission: false,
      writePermission: false,
      isPermissionDenied: false,
      summaryData: null,
      filters: {
        tenantIds: '',
      },
      tenantOptions: [],
      pageSize: 1000, // Set high default to fetch all data
      downloadingPDF: false,
      downloadingExcel: false,
    }
  },
  mounted() {
    this.checkPermissions()
    if (!this.isPermissionDenied) {
      this.fetchTenants()
      this.fetchLicensedPageData()
    }
    document.addEventListener('click', this.handleClickAway)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickAway)
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = permissions.some((p) => p.object_name === 'LICENSE_PAGE_EXPIRY_REPORT_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'LICENSE_PAGE_EXPIRY_REPORT_WR' && p.is_active)

      if (!this.readPermission) {
        this.isPermissionDenied = true
        return
      }

      this.isPermissionDenied = false
    },

    async fetchTenants() {
      try {
        const res = await get('/v1/tenants?page=1&pageSize=10000')

        console.log('Tenant API Response:', res.data)

        // Handle the specific API response structure
        if (res?.data?.code === 200 && res?.data?.data?.tenants) {
          const tenants = res.data.data.tenants

          this.tenantOptions = tenants.map((tenant) => ({
            value: tenant.id,
            label: tenant.tenant_name,
          }))

          console.log('Processed tenantOptions:', this.tenantOptions)
        } else {
          console.log('No tenants found in response')
          this.tenantOptions = []
        }
      } catch (err) {
        console.error('Failed to fetch tenants:', err)
        showToast({
          title: this.$t('reports.toast.error'),
          message: 'Failed to load tenant options',
          type: 'error',
        })
      }
    },

    async fetchLicensedPageData() {
      this.loading = true
      try {
        const params = {
          page: 1, // Always fetch from page 1
          pageSize: this.pageSize, // Use high page size to get all data
          ...this.filters,
        }

        // Remove empty tenantIds
        if (!params.tenantIds || params.tenantIds === '') {
          delete params.tenantIds
        }

        // Remove empty filter values
        Object.keys(params).forEach((key) => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const queryString = new URLSearchParams(params).toString()
        const res = await get(`/v1/reports/licensed-page-expiry?${queryString}`)

        if (res?.data) {
          this.licensedPageData = res.data.data || []
          this.summaryData = {
            total_count: res.data.total_count || 0,
            threshold_percent: res.data.threshold_percent || '',
            generated_on: res.data.generated_on || '',
          }
        }
      } catch (error) {
        console.error('Failed to fetch licensed page data:', error)
        showToast({
          title: this.$t('reports.toast.error'),
          message: error.response?.data?.message || this.$t('reports.toast.failed_to_load'),
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    handleFilterChange() {
      // Debounced filter change can be implemented here if needed
    },

    generateReport() {
      this.fetchLicensedPageData()
    },

    handleSearch() {
      this.fetchLicensedPageData()
    },

    resetAllFilters() {
      this.filters = {
        tenantIds: '',
      }
      this.fetchLicensedPageData()
    },

    getPagesRemainingClass(pagesRemaining) {
      if (pagesRemaining < 0) return 'critical'
      if (pagesRemaining <= 10) return 'warning'
      return 'good'
    },

    getStatusClass(status) {
      switch (status?.toLowerCase()) {
        case 'critical':
          return 'critical'
        case 'high utilization':
          return 'warning'
        default:
          return 'good'
      }
    },

    async downloadAsPDF() {
      if (!this.writePermission) {
        showToast({
          title: this.$t('common.no_permission'),
          message: this.$t('reports.no_write_permission'),
          type: 'error',
        })
        return
      }

      this.downloadingPDF = true
      try {
        // Prepare params for fetching all data with export flag
        const params = {
          export: true,
          ...this.filters,
        }

        // Remove empty tenantIds
        if (!params.tenantIds || params.tenantIds === '') {
          delete params.tenantIds
        }

        // Remove empty filter values
        Object.keys(params).forEach((key) => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        // For PDF generation, we need structured data, not CSV
        // Remove export flag and fetch normal data
        const pdfParams = { ...params }
        delete pdfParams.export
        const pdfQueryString = new URLSearchParams(pdfParams).toString()
        const res = await get(`/v1/reports/licensed-page-expiry?${pdfQueryString}`)

        let allLicensedPageData = []
        if (res?.data) {
          allLicensedPageData = res.data.data || []
        }

        if (allLicensedPageData.length === 0) {
          showToast({
            title: this.$t('reports.toast.no_data'),
            message: this.$t('licensedPageExpiry.toast.no_data'),
            type: 'warning',
          })
          return
        }

        // Generate PDF content
        this.generatePDF(allLicensedPageData)
      } catch (error) {
        showToast({
          title: this.$t('reports.toast.error'),
          message: error.response?.data?.message || this.$t('reports.toast.failed_download'),
          type: 'error',
        })
      } finally {
        this.downloadingPDF = false
      }
    },

    generatePDF(data) {
      const currentDate = new Date().toISOString().split('T')[0]
      // const filterSuffix = this.getFilterSuffix() // Commented out since filters are disabled

      const printWindow = window.open('', '_blank')
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${this.$t('licensedPageExpiry.pdfTitle')}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .title { font-size: 24px; font-weight: bold; color: #333; }
            .subtitle { font-size: 14px; color: #666; margin-top: 5px; }
            .filters { margin-bottom: 20px; font-size: 12px; color: #666; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 12px; }
            th { background-color: #f5f5f5; font-weight: bold; }
            .status-critical { color: #d32f2f; font-weight: bold; }
            .status-warning { color: #f57c00; font-weight: bold; }
            .status-good { color: #388e3c; font-weight: bold; }
            .summary { margin-bottom: 20px; padding: 15px; background-color: #f9f9f9; border-radius: 5px; }
            .summary-item { display: inline-block; margin-right: 20px; }
            .summary-label { font-weight: bold; margin-right: 5px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">${this.$t('licensedPageExpiry.pdfTitle')}</div>
            <div class="subtitle">${this.$t('licensedPageExpiry.generatedOn')}: ${currentDate}</div>
          </div>
          
          ${this.generateFiltersInfo()}
          
          <div class="summary">
            <div class="summary-item">
              <span class="summary-label">${this.$t('licensedPageExpiry.totalTenants')}:</span>
              <span>${this.summaryData?.total_count || 0}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">${this.$t('licensedPageExpiry.thresholdPercent')}:</span>
              <span>${this.summaryData?.threshold_percent || 85}%</span>
            </div>
          </div>
          
          <table>
            <thead>
              <tr>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.tenantId')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.tenantName')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.pagesLicensed')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.pagesProcessed')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.pagesRemaining')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.utilizationPercent')}</th>
                <th>${this.$t('licensedPageExpiry.pdfHeaders.status')}</th>
              </tr>
            </thead>
            <tbody>
              ${data
                .map(
                  (item) => `
                <tr>
                  <td>${item.tenant_id || ''}</td>
                  <td>${item.tenant_name || ''}</td>
                  <td>${item.pages_licensed || 0}</td>
                  <td>${item.pages_processed || 0}</td>
                  <td>${item.pages_remaining || 0}</td>
                  <td>${item.utilization_percent?.toFixed(2) || 0}%</td>
                  <td class="status-${this.getStatusClass(item.status)}">${this.$t(`licensedPageExpiry.status.${item.status?.toLowerCase().replace(' ', '_')}`)}</td>
                </tr>
              `
                )
                .join('')}
            </tbody>
          </table>
        </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.print()

      showToast({
        title: this.$t('reports.toast.success'),
        message: this.$t('reports.toast.pdf_exported'),
        type: 'success',
      })
    },

    generateFiltersInfo() {
      const activeFilters = []

      if (this.filters.tenantIds && this.filters.tenantIds !== '') {
        const selectedTenant = this.tenantOptions.find((option) => option.value === this.filters.tenantIds)
        activeFilters.push(`${this.$t('licensedPageExpiry.tenantIds')}: ${selectedTenant?.label || this.filters.tenantIds}`)
      }

      if (activeFilters.length === 0) {
        return ''
      }

      return `<div class="filters">${this.$t('licensedPageExpiry.appliedFilters')}: ${activeFilters.join(', ')}</div>`
    },

    async downloadAsExcel() {
      if (!this.writePermission) {
        showToast({
          title: this.$t('common.no_permission'),
          message: this.$t('reports.no_write_permission'),
          type: 'error',
        })
        return
      }

      this.downloadingExcel = true
      try {
        // Prepare params for fetching all data with export flag
        const params = {
          export: true,
          ...this.filters,
        }

        // Remove empty tenantIds
        if (!params.tenantIds || params.tenantIds === '') {
          delete params.tenantIds
        }

        // Remove empty filter values
        Object.keys(params).forEach((key) => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const queryString = new URLSearchParams(params).toString()

        // Use getBinary to fetch CSV data
        const res = await get(`/v1/reports/licensed-page-expiry?${queryString}`)

        // The API returns CSV data directly as text
        let csvData = ''
        if (res?.data) {
          // If the response is already a string (CSV), use it directly
          if (typeof res.data === 'string') {
            csvData = res.data
          } else {
            // If it's an object, try to extract CSV from a property
            csvData = res.data.csv || res.data.data || ''
          }
        }

        if (!csvData || csvData.trim().length === 0) {
          showToast({
            title: this.$t('reports.toast.no_data'),
            message: this.$t('licensedPageExpiry.toast.no_data'),
            type: 'warning',
          })
          return
        }

        // Download the CSV data directly
        this.downloadCSV(csvData)
      } catch (error) {
        showToast({
          title: this.$t('reports.toast.error'),
          message: error.response?.data?.message || this.$t('reports.toast.failed_download'),
          type: 'error',
        })
      } finally {
        this.downloadingExcel = false
      }
    },

    downloadCSV(csvData) {
      // Create and download the file
      const blob = new Blob(['\uFEFF' + csvData], {
        type: 'text/csv;charset=utf-8;',
      })

      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)

      // Generate filename with current date and applied filters info
      const currentDate = new Date().toISOString().split('T')[0]
      const filterSuffix = this.getFilterSuffix()
      link.setAttribute('download', `licensed_page_expiry_report_${currentDate}${filterSuffix}.csv`)

      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Clean up the URL object
      URL.revokeObjectURL(url)

      showToast({
        title: this.$t('reports.toast.success'),
        message: this.$t('reports.toast.excel_exported'),
        type: 'success',
      })
    },

    getFilterSuffix() {
      const activeFilters = []

      if (this.filters.tenantIds && this.filters.tenantIds !== '') {
        activeFilters.push(`tenant_${this.filters.tenantIds}`)
      }

      return activeFilters.length > 0 ? `_${activeFilters.join('_')}` : ''
    },
  },
}
</script>

<style scoped>
.licensed-page-expiry-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  overflow-x: hidden;
}

.licensed-page-expiry-wrapper {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Permission Denied Message */
.permission-denied {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.permission-denied-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 500px;
}

.permission-denied-content h2 {
  color: #dc3545;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}

.permission-denied-content p {
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #666;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Generate Report Section */
.generate-report-section {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.generate-report-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(22, 72, 99, 0.2);
}

.generate-report-button:hover:not(:disabled) {
  background: #337497;
  box-shadow: 0 4px 8px rgba(22, 72, 99, 0.3);
  transform: translateY(-1px);
}

.generate-report-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.generate-report-button svg {
  width: 16px;
  height: 16px;
}

/* Filters Section */
.filters-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filters-container {
  display: flex;
  gap: 20px;
  align-items: end;
  flex-wrap: wrap;
}

.filterGroup {
  display: flex;
  flex-direction: column;
  min-width: 200px;
}

.filterLabel {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.filterInput {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.filterInput:focus {
  outline: none;
  border-color: #007bff;
}

.filterButtonGroup {
  display: flex;
  gap: 10px;
}

.resetDateButton {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.resetDateButton:hover {
  background-color: #0056b3;
}

/* Summary Section */
.summary-section {
  margin-bottom: 20px;
}

.summary-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.summary-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* Pagination Controls */
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pagination-info {
  font-size: 14px;
  color: #666;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.pagination-button {
  padding: 8px 16px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination-button:hover:not(:disabled) {
  background-color: #e9ecef;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}

.page-size-controls {
  position: relative;
}

.page-size-dropdown {
  position: relative;
}

.page-size-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-size-button:hover {
  background-color: #e9ecef;
}

.dropdown-icon {
  transition: transform 0.2s;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.page-size-options {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 80px;
}

.page-size-option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.page-size-option:hover {
  background-color: #f8f9fa;
}

.page-size-option.active {
  background-color: #007bff;
  color: white;
}

/* Download Section */
.download-section {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.download-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}





.download-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Table Container */
.table-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background-color: #f8f9fa;
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  border-bottom: 2px solid #dee2e6;
}

.data-table td {
  padding: 12px;
  font-size: 14px;
  color: #555;
  border-bottom: 1px solid #dee2e6;
}

.data-table tr:hover {
  background-color: #f8f9fa;
}

/* Status and Pages Badges */
.pages-badge,
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.pages-badge.critical,
.status-badge.critical {
  background-color: #fee;
  color: #d32f2f;
}

.pages-badge.warning,
.status-badge.warning {
  background-color: #fff3e0;
  color: #f57c00;
}

.pages-badge.good,
.status-badge.good {
  background-color: #e8f5e8;
  color: #388e3c;
}

/* No Data Message */
.no-data {
  padding: 40px;
  text-align: center;
  color: #666;
  font-size: 16px;
}

.downloadExcelButton {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 2rem;
  padding: 0 1.5rem;
  border-radius: 6px;
  border: none;
  background: var(--primary-color);
  color: #fff;
  font-family: Lato, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 2px 4px rgba(22, 72, 99, 0.2);
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}


.downloadExcelButton svg {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .licensed-page-expiry-wrapper {
    padding: 15px;
  }

  .filters-container {
    flex-direction: column;
    align-items: stretch;
  }

  .filterGroup {
    min-width: auto;
  }

  .pagination-controls {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .summary-card {
    flex-direction: column;
    gap: 15px;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 6px;
  }
}
</style>
